import { render } from "./dictToJson.vue?vue&type=template&id=3c55122c"
import script from "./dictToJson.vue?vue&type=script&lang=js"
export * from "./dictToJson.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__